import { Component, Host, h, Prop, State, Event, EventEmitter } from '@stencil/core';

import store from '../../store';

export interface LoadMoreData {
  [key: string]: number;
}

@Component({
  tag: 'ui-cms-blog-load-more-comments',
  styleUrl: 'ui-cms-blog-load-more-comments.scss',
  shadow: false,
})
export class UiCmsBlogLoadMoreComments {
  @Prop() loadMoreID: string;

  @Prop() initialShownComments: number;

  @Prop() totalComments: number;

  @State() shownComments: number;

  @State() loadMoreBtnTitle: string;

  @State() loadMoreBtnIcon: string;

  @Event() loadMoreOffset: EventEmitter<{ data: LoadMoreData }>;

  componentDidLoad() {
    this.loadMoreBtnTitle = store.state.i18n.loadMoreComments;
    this.loadMoreBtnIcon = 'chevron-bottom';

    // set initial number of shown comments
    this.shownComments = this.initialShownComments;
  }

  private updateBtnInfo() {
    if (this.shownComments < this.totalComments) {
      this.loadMoreBtnTitle = store.state.i18n.loadMoreComments;
      this.loadMoreBtnIcon = 'chevron-bottom';
    } else {
      this.loadMoreBtnTitle = store.state.i18n.hideComments;
      this.loadMoreBtnIcon = 'chevron-top';
    }
  }

  private loadMoreComments() {
    if (this.shownComments < this.totalComments) {
      this.shownComments += this.initialShownComments;
    } else {
      this.shownComments = this.initialShownComments;
    }

    // key is the id of the load more button / value is the number of shown-comments/offset
    // the id is used to identify the load more button since there can be multiple load more buttons in the same component
    this.loadMoreOffset.emit({ data: { [this.loadMoreID]: this.shownComments } });

    this.updateBtnInfo();
  }

  render() {
    return (
      <Host>
        {this.totalComments > this.initialShownComments && (
          <ui-button variant="transparent" icon={this.loadMoreBtnIcon} onClick={() => this.loadMoreComments()}>
            {this.loadMoreBtnTitle}
          </ui-button>
        )}
      </Host>
    );
  }
}
